import type { RouteMapItem } from "../types/routes";
import { haversineM, pointToPolylineM } from "./geo";
import type { LatLon } from "./types";

// Сколько карточек в блоке «Маршруты рядом» экрана поиска.
export const NEARBY_ROUTES_COUNT = 5;

// Расстояние от точки до маршрута: до линии превью ([lon, lat] из GET /routes),
// без неё - до точки старта; ничего нет - null.
export const routeDistanceM = (from: LatLon, r: RouteMapItem): number | null => {
  if (r.preview_line?.length) return pointToPolylineM(from, r.preview_line.map(([lon, lat]) => [lat, lon]));
  if (r.start_lat != null && r.start_lon != null) return haversineM(from, { lat: r.start_lat, lon: r.start_lon });
  return null;
};

// Ближайшие маршруты; без точки отсчёта - первые по порядку стора, без расстояний.
export const nearbyRoutes = (
  routes: RouteMapItem[],
  from: LatLon | null,
  count = NEARBY_ROUTES_COUNT
): { route: RouteMapItem; meters: number | null }[] => {
  if (!from) return routes.slice(0, count).map((route) => ({ route, meters: null }));
  return routes
    .map((route) => ({ route, meters: routeDistanceM(from, route) }))
    .sort((a, b) => (a.meters ?? Infinity) - (b.meters ?? Infinity))
    .slice(0, count);
};
